module.exports = __webpack_public_path__ + "media/flags/ae-70d0c456.svg";